export const BULKIMPORT_SET = "BULK_IMPORT"
export const BULKIMPORT_SET_SUCCESS = "SUCCESS"
export const BULKIMPORT_SET_ERROR = "ERROR"
export const ORG_DETAIL_GET_LIST="ORG_DETAIL_GET_LIST"
export const ORG_DETAIL_GET_LIST_SUCCESSFULL="ORG_DETAIL_GET_LIST_SUCCESSFULL"
export const ORG_DETAIL_GET_LIST_FAILED="ORG_DETAIL_GET_LIST_FAILED"
// candidate bulk import
export const CANDIDATE_SET="CANDIDATE_BULK_IMPORT"

//job bulk import
export const JOB_SET="JOB_BULK_IMPORT"

export const GET_JOB_PROFILES="GET_JOB_PROFILES"
export const GET_JOB_PROFILES_SUCCESS="GET_JOB_PROFILES_SUCCESS"
export const GET_JOB_PROFILES_FAILED="GET_JOB_PROFILES_FAILED"


export const GET_JOB_PROFILES_SUGGESTION="GET_JOB_PROFILES_SUGGESTION"
export const GET_JOB_PROFILES_SUGGESTION_SUCCESS="GET_JOB_PROFILES_SUGGESTION_SUCCESS"
export const GET_JOB_PROFILES_SUGGESTION_FAILED="GET_JOB_PROFILES_SUGGESTION_FAILED"

//candidate bulkimport statuses

export const GET_CANDIDATE_BULK_IMPORT_STATUS="GET_CANDIDATE_BULK_IMPORT_STATUS"
export const GET_CANDIDATE_BULK_IMPORT_STATUS_SUCCESS="GET_CANDIDATE_BULK_IMPORT_STATUS_SUCCESS"
export const GET_CANDIDATE_BULK_IMPORT_STATUS_FAILED="GET_CANDIDATE_BULK_IMPORT_STATUS_FAILED"

export const DELETE_ALL_RESUMES="DELETE_ALL_RESUMES"
export const DELETE_ALL_RESUMES_SUCCESS="DELETE_ALL_RESUMES_SUCCESS"
export const DELETE_ALL_RESUMES_FAILED="DELETE_ALL_RESUMES_FAILED"

//job bulk import statuses

export const GET_JOB_BULK_IMPORT_STATUS="GET_JOB_BULK_IMPORT_STATUS"
export const GET_JOB_BULK_IMPORT_STATUS_SUCCESS="GET_JOB_BULK_IMPORT_STATUS_SUCCESS"
export const GET_JOB_BULK_IMPORT_STATUS_FAILED="GET_JOB_BULK_IMPORT_STATUS_FAILED"

export const DELETE_ALL_DESCRIPTIONS="DELETE_ALL_DESCRIPTIONS"
export const DELETE_ALL_DESCRIPTIONS_SUCCESS="DELETE_ALL_DESCRIPTIONS_SUCCESS"
export const DELETE_ALL_DESCRIPTIONS_FAILED="DELETE_ALL_DESCRIPTIONS_FAILED"



export const DELETE_JD_REPOSITORY = "DELETE_JD_REPOSITORY"
export const DELETE_JD_REPOSITORY_STATUS_SUCCESS =  "DELETE_JD_REPOSITORY_STATUS_SUCCESS"
export const DELETE_JD_REPOSITORY_STATUS_FAIL = "DELETE_JD_REPOSITORY_STATUS_FAIL"

export const GET_SAMPLE_CSV_JD_FILE="GET_SAMPLE_CSV_JD_FILE"
export const GET_SAMPLE_CSV_JD_FILE_SUCCESS="GET_SAMPLE_CSV_JD_FILE_SUCCESS"
export const GET_SAMPLE_CSV_JD_FILE_FAILED="GET_SAMPLE_CSV_JD_FILE_FAILED"

export const GET_SAMPLE_CSV_RESUME_FILE="GET_SAMPLE_CSV_RESUME_FILE"
export const GET_SAMPLE_CSV_RESUME_FILE_SUCCESS="GET_SAMPLE_CSV_RESUME_FILE_SUCCESS"
export const GET_SAMPLE_CSV_RESUME_FILE_FAILED="GET_SAMPLE_CSV_RESUME_FILE_FAILED"